import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import { CartProvider } from './contexts/CartContext';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-1192">
    <AuthProvider data-id="element-1193">
      <DataProvider data-id="element-1194">
        <FavoritesProvider data-id="element-1195">
          <CartProvider data-id="element-1196">
            <App data-id="element-1197" />
          </CartProvider>
        </FavoritesProvider>
      </DataProvider>
    </AuthProvider>
  </React.StrictMode>);